import * as React from 'react';

import { ISavedSearch } from '../../../../types/savedSearch';
import { SearchCardsItem } from '../SearchCardsItem';

import * as styles from './styles.css';

export interface ISavedSearchesListProps {
  data: ISavedSearch[];
  isEmailConfirmed: boolean;
  onFrequencyChange: (frequency: string | null, id?: number) => void;
  onSearchRemove: (id: number) => void;
}

export const SavedSearchesList: React.FC<ISavedSearchesListProps> = ({
  data,
  isEmailConfirmed,
  onSearchRemove,
  onFrequencyChange,
}) => {
  return (
    <div className={styles['wrapper']}>
      <div className={styles['container']}>
        {data.map(item => (
          <div className={styles['card-wrapper']} key={`item_${item.id}`} data-name="saved-search-card">
            <SearchCardsItem
              title={item.name}
              description={item.description}
              frequency={item.frequency}
              selectedFrequency={item.selectedFrequency}
              link={item.link}
              status={item.status}
              newOffersCount={item.newOffersCount}
              hasNewOffers={Boolean(item.newOffersCount)}
              isEmailConfirmed={isEmailConfirmed}
              onRemove={() => onSearchRemove(item.id as number)}
              onFrequencyChange={(frequency: string | null) => onFrequencyChange(frequency, item.id)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
